// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i0-0";
export var animationContainer = "_i0-1";
export var modalContent = "_i0-2";
export var orderName = "_i0-3";
export var refundOption = "_i0-4";
export var refundOptionsContainer = "_i0-5";